import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";
import Service from "../../../../api/api-service";
import { ApiUrl } from "../../../../api/api-url";
import { CONSTANT } from "../../../../constants/constant";
const service = new Service();

export const GET_TITLE_LOOKUP_OK = "GET_TITLE_LOOKUP_OK";
export const GET_TITLE_LOOKUP_ERR = "GET_TITLE_LOOKUP_ERR";

export const titleAction = {
  getTitleLookup,
};

function getTitleLookupOk(payload) {
  return { type: GET_TITLE_LOOKUP_OK, payload };
}
function getTitleLookupErr(payload) {
  return { type: GET_TITLE_LOOKUP_ERR, payload };
}

function getTitleLookup() {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .get(ApiUrl.GetLookupTitle)
      .then((response) => {
        dispatch(getTitleLookupOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
      })
      .catch((error) => {
        dispatch(getTitleLookupErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        if (error && error.errorMessage) {
          ShowNotification(error.errorMessage, NotificationMessageType.Error);
        } else {
          ShowNotification(
            CONSTANT.message.error_unknown,
            NotificationMessageType.Error
          );
        }
      });
  };
}
